// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.sidenav[data-v-2b38bd30] {
  position: fixed;
  top: 0;
  left: 0;
  width: 220px;
  height: 100vh;
  background: #1a1a2e;
  display: flex;
  flex-direction: column;
  z-index: 100;
}
.sidenav-header[data-v-2b38bd30] {
  padding: 24px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.user-info[data-v-2b38bd30] {
  display: flex;
  align-items: center;
  gap: 12px;
}
.user-logo[data-v-2b38bd30] {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  -o-object-fit: cover;
     object-fit: cover;
}
.user-logo-placeholder[data-v-2b38bd30] {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 16px;
}
.user-text[data-v-2b38bd30] {
  flex: 1;
  min-width: 0;
}
.company-name[data-v-2b38bd30] {
  font-size: 14px;
  font-weight: 600;
  color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.user-name[data-v-2b38bd30] {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sidenav-footer[data-v-2b38bd30] {
  margin-top: auto;
  padding: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}
.sidenav-item[data-v-2b38bd30] {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
  color: rgba(255, 255, 255, 0.7);
}
.sidenav-item[data-v-2b38bd30]:hover {
  background: rgba(255, 255, 255, 0.1);
  color: white;
}
.sidenav-icon[data-v-2b38bd30] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}
.sidenav-text[data-v-2b38bd30] {
  font-size: 14px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
